import { ReactNode } from "react";

import ModalContent from "../modal/ModalContent";
import OpenModalButton from "../helper-components/OpenModalButton";
import SignInOptions from "./SignInOptions";
import SignUpOptions from "./SignUpOptions";

export default function AuthenticationPage({
  children,
  isSignUpPage,
  hideAnonymousOption,
}: {
  children: ReactNode;
  isSignUpPage: boolean;
  hideAnonymousOption?: boolean;
}) {
  return (
    <ModalContent className="grid place-items-center py-10 px-14 text-center max-w-[678px] max-h-[695px] w-full h-full animate-fade-scale-in">
      <h2 className="font-arial tracking-[-0.03em] text-[28px]">
        {isSignUpPage ? "Join BlogJedi." : "Welcome back."}
      </h2>

      <div className="w-full rounded py-10 bg-white flex flex-col justify-center items-center">
        <div className="w-[212px] flex flex-col gap-3">{children}</div>

        <p className="mt-10">
          <span>
            {isSignUpPage ? "Already have an account? " : "No account? "}
          </span>
          <OpenModalButton
            element={
              isSignUpPage ? (
                <SignInOptions hideAnonymousOption={hideAnonymousOption} />
              ) : (
                <SignUpOptions hideAnonymousOption={hideAnonymousOption} />
              )
            }
          >
            <b className="text-green hover:text-dark-green leading-6 font-sohne">
              {isSignUpPage ? "Sign In" : "Create one"}
            </b>
          </OpenModalButton>
        </p>
      </div>

      <p className="text-[13px] text-neutral-500">
        Click “{isSignUpPage ? "Sign Up" : "Sign In"}” to agree to BlogJedi’s{" "}
        <span className="underline cursor-pointer">
          <a href="https://adminjedi.web.app/terms-and-conditions.html">
            Terms of Service
          </a>
        </span>{" "}
        and acknowledge that BlogJedi’s{" "}
        <span className="underline cursor-pointer">
          <a href="https://adminjedi.web.app/privacy-policy.html">
            Privacy Policy
          </a>
        </span>{" "}
        applies to you.
      </p>
    </ModalContent>
  );
}
